import { render, staticRenderFns } from "./ProductCart.vue?vue&type=template&id=5fbc8eac&scoped=true"
import script from "./ProductCart.vue?vue&type=script&lang=js"
export * from "./ProductCart.vue?vue&type=script&lang=js"
import style0 from "./ProductCart.vue?vue&type=style&index=0&id=5fbc8eac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc8eac",
  null
  
)

export default component.exports